module.exports = __webpack_public_path__ + "static/media/dodgem(8).20e45b0e.PNG";